import { NgModule } from '@angular/core';

import { SharedModule } from '../../../shared/shared.module';
import { DatePipe } from '@angular/common';
import { SolicitacaoHonraRoutingModule } from './solicitacao-honra-routing.module';
import { SolicitacaoHonraPesquisaComponent } from './solicitacao-honra-pesquisa.component';
import { SolicitacaoHonraListagemComponent } from './solicitacao-honra-listagem.component';
import { SolicitacaoHonraDetalheComponent } from './solicitacao-honra-detalhe.component';
import { SolicitacaoHonraLotePesquisaComponent } from '../protocolo/solicitacao-honra-lote-pesquisa.component';
import { SolicitacaoHonraLoteEnvioComponent } from '../protocolo/solicitacao-honra-lote-envio.component';
import { SolicitacaoHonraCadastroComponent } from '../protocolo/solicitacao-honra-cadastro.component';
import { SolicitacaoHonraPrioridadeComponent } from '../protocolo/solicitacao-honra-prioridade.component';
import { ArquivoPopupComponent } from './arquivo-popup.component';
import { BnMaskPipe } from "@bndes/bndes-ux4/bn-mask/bn-mask-pipe";
import { JanelaSolicitacaoHonraPesquisaComponent } from '../janela/janela-solicitacao-honra-pesquisa/janela-solicitacao-honra-pesquisa.component';
import { JanelaSolicitacaoHonraListagemComponent } from '../janela/janela-solicitacao-honra-listagem/janela-solicitacao-honra-listagem.component';

@NgModule({
  imports: [
    SharedModule,
    SolicitacaoHonraRoutingModule
  ],
  exports: [
    SolicitacaoHonraListagemComponent
  ],
  declarations: [
    ArquivoPopupComponent,
    SolicitacaoHonraPesquisaComponent,
    SolicitacaoHonraListagemComponent,
    SolicitacaoHonraDetalheComponent,
    SolicitacaoHonraLoteEnvioComponent,
    SolicitacaoHonraLotePesquisaComponent,
    SolicitacaoHonraCadastroComponent,
    SolicitacaoHonraPrioridadeComponent,
    JanelaSolicitacaoHonraPesquisaComponent,
    JanelaSolicitacaoHonraListagemComponent,
  ],
  providers: [
    DatePipe,
    BnMaskPipe,
  ]
})
export class SolicitacaoHonraModule { }
